// removed by extract-text-webpack-plugin
module.exports = {"publicspan":"wmf-E_npniyO","page":"wmf-3LbXi_w-"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commoditymanagementlist/commodity-management-list.module.less
// module id = 1014
// module chunks = 0